import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserProfileComponent} from './user-profile.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MaterialModule} from "../../../material.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {RouterModule} from "@angular/router";
import {AvatarModule} from "../../avatar/avatar.module";
import {DocumentUploadModule} from "../../document-upload/document-upload.module";
import { UserClientsComponent } from './user-clients/user-clients.component';

@NgModule({
    declarations: [UserProfileComponent, UserClientsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule,
    AvatarModule,
    DocumentUploadModule
  ]
})
export class UserProfileModule {
}
